<template>
  <v-container :style="{ maxWidth: '1260px'}" class="mb-10 lr-page">
    <!-- <h3 class="text-right">
      <v-btn
                color="#205295"
                dark
                class="mb-2 rounded-pill"
              >
              {{ lg_listroom1.create_new_meeting }}
                 <v-icon
        right
        dark
      >
        mdi-plus
      </v-icon>
              </v-btn>
    </h3> -->
    <!-- <v-icon color="red">mdi-shield-account</v-icon>
      {{ lg_listroom1.title_remark }} -->
    <!-- ===== Toolbar: ค้นหา + สร้างห้อง ===== -->
    <div class="lr-toolbar">
      <div class="lr-search">
        <v-icon size="18" color="#94a3b8">mdi-magnify</v-icon>
        <input
          v-model="search"
          type="text"
          :placeholder="lg_listroom1.lr_search_placeholder || lg_listroom1.room_search"
        />
        <button v-if="search" type="button" class="lr-search-clear" @click="search = ''">
          <v-icon size="16" color="#94a3b8">mdi-close-circle</v-icon>
        </button>
      </div>

      <button type="button" class="lr-btn lr-btn--primary lr-btn--create" @click="Clickdialogcreate()">
        <v-icon size="18" color="#ffffff">mdi-plus</v-icon>
        {{ lg_listroom1.create_new_meeting }}
      </button>
    </div>

    <!-- ===== ไม่มีห้อง ===== -->
    <div v-if="mDataArray.length == 0" class="lr-empty">
      <span class="lr-empty-icon">
        <v-icon size="28" color="#215295">mdi-video-outline</v-icon>
      </span>
      <h2>{{ lg_listroom1.no_meeting_room }}</h2>
    </div>

    <v-data-iterator
      v-else
      :items="mDataArray"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
    <!--  flat
            solo-inverted 
            prepend-inner-icon="mdi-magnify"-->
      <!-- <template v-slot:header>
      </template> -->


      <template v-slot:default="props">
        <!-- หัวคอลัมน์ -->
        <div class="lr-head">
          <span>{{ lg_listroom1.lr_col_meeting }}</span>
          <span>{{ lg_listroom1.lr_col_dates }}</span>
          <span>{{ lg_listroom1.lr_col_settings }}</span>
          <span class="lr-head-actions">{{ lg_listroom1.lr_col_actions }}</span>
        </div>

        <div
          v-for="item in props.items"
          :key="item.meet_name"
          class="lr-card"
        >
          <!-- ===== Meeting ===== -->
          <div class="lr-col lr-col--meeting">
            <h3 class="lr-title">{{ item.meet_topic }}</h3>
            <p class="lr-id">{{ lg_listroom1.room_id }} · {{ item.meet_name }}</p>
            <span v-if="isLive(item)" class="lr-status lr-status--live">
              <i class="lr-dot"></i>{{ lg_listroom1.lr_status_live }}
            </span>
            <span v-else class="lr-status lr-status--scheduled">
              {{ lg_listroom1.lr_status_scheduled }}
            </span>
          </div>

          <!-- ===== Dates ===== -->
          <div class="lr-col lr-col--dates">
            <p class="lr-label">{{ lg_listroom1.lr_created }}</p>
            <p class="lr-date">{{ fmtDay(item.meet_create) }}</p>
            <p class="lr-time">{{ fmtTime(item.meet_create) }} · GMT+7</p>

            <p class="lr-label mt-3">{{ lg_listroom1.lr_scheduled }}</p>
            <p class="lr-date" :class="{ 'lr-date--live': isLive(item) }">{{ fmtDay(item.meet_start) }}</p>
            <p class="lr-time">{{ fmtTime(item.meet_start) }} · GMT+7</p>
          </div>

          <!-- ===== Settings ===== -->
          <div class="lr-col lr-col--settings">
            <div class="lr-tags">
              <span v-if="item.meet_verify_sta && item.meet_verify_sta !== 'N'" class="lr-tag">
                <v-icon size="13" color="#215295">mdi-cellphone</v-icon>{{ lg_listroom1.lr_tag_otp }}
              </span>
              <span v-if="item.meet_pass" class="lr-tag">
                <v-icon size="13" color="#215295">mdi-lock-outline</v-icon>{{ lg_listroom1.lr_tag_passcode }}
              </span>
              <span v-if="item.meet_verify_login && item.meet_verify_login !== 'N'" class="lr-tag">
                <v-icon size="13" color="#215295">mdi-account-key-outline</v-icon>{{ lg_listroom1.lr_tag_signin }}
              </span>
              <span v-if="item.meet_record_on_start_sta && item.meet_record_on_start_sta !== 'N'" class="lr-tag lr-tag--red">
                <i class="lr-dot lr-dot--red"></i>{{ lg_listroom1.lr_tag_record }}
              </span>
              <span v-if="item.meet_lobby_sta && item.meet_lobby_sta !== 'N'" class="lr-tag">
                <v-icon size="13" color="#215295">mdi-clock-outline</v-icon>{{ lg_listroom1.lr_tag_waiting }}
              </span>
            </div>

            <div v-if="item.meet_pass" class="lr-pass">
              <v-icon size="15" color="#64748b">mdi-lock-outline</v-icon>
              <span class="lr-pass-label">{{ lg_listroom1.password }}</span>
              <span class="lr-pass-value" :class="{ 'is-hidden': !visiblePass[item.meet_name] }">
                {{ visiblePass[item.meet_name] ? item.meet_pass : '••••••' }}
              </span>
              <button type="button" class="lr-icon-btn" @click="togglePass(item)">
                <v-icon size="15" color="#94a3b8">{{ visiblePass[item.meet_name] ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
              </button>
            </div>
          </div>

          <!-- ===== Actions ===== -->
          <div class="lr-col lr-col--actions">
            <div class="lr-actions-top">
              <button
                type="button"
                class="lr-btn lr-btn--ghost lr-btn--sm"
                @click="assignMessage(item)"
                v-clipboard:copy="message"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <v-icon size="15" color="#475569">mdi-content-copy</v-icon>
                {{ lg_listroom1.dialog_invite_copy_link }}
              </button>

              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <button type="button" class="lr-btn lr-btn--ghost lr-btn--sm lr-btn--icon" v-bind="attrs" v-on="on">
                    <v-icon size="18" color="#475569">mdi-dots-horizontal</v-icon>
                  </button>
                </template>

                <v-list dense>
                  <v-list-item link @click="moreinfodialogfn(item)">
                    <v-list-item-title>{{ lg_listroom1.more_info }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item link @click="dialogCloseMeetion(item)" style="color:red;">
                    <v-list-item-title color="#FF5733">{{ lg_listroom1.delete_this_meeting }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
      <!-- <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               :style=" $vuetify.breakpoint.xsOnly 
              ? { float: 'right', marginRight: '20px', marginTop: '-50px' } 
              : {} "
              color="black"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon v-if="$vuetify.breakpoint.xsOnly">mdi-dots-horizontal</v-icon>
                <v-icon v-else>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
              link
               @click="moreinfodialogfn(item)"
              >
                <v-list-item-title >
          {{ lg_listroom1.more_info }}
                  </v-list-item-title>
              </v-list-item>

              <v-list-item
              link
               @click="dialogCloseMeetion(item)"
                style="color:red;"
              >
                <v-list-item-title color="#FF5733">{{ lg_listroom1.delete_this_meeting }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
            </div>

            <!-- btn invite and join -->
            <div class="lr-actions-main">
              <button type="button" class="lr-btn lr-btn--outline" @click="openInviteModal(item)">
                <v-icon size="16" color="#215295">mdi-email-outline</v-icon>
                {{ lg_listroom1.btn_invite }}
              </button>

              <button v-if="checkRoleAdmin" type="button" class="lr-btn lr-btn--primary" @click="onClickJoinMeetion(item)">
                <v-icon size="16" color="#ffffff">mdi-video-outline</v-icon>
                {{ lg_listroom1.btn_join }}
                <v-icon size="16" color="#ffffff">mdi-chevron-right</v-icon>
              </button>
              <button v-if="!checkRoleAdmin" type="button" class="lr-btn lr-btn--primary" @click="onClickJoinMeetion(item)">
                <v-icon size="16" color="#ffffff">mdi-video-outline</v-icon>
                {{ lg_listroom1.btn_join }}
                <v-icon size="16" color="#ffffff">mdi-chevron-right</v-icon>
              </button>
            </div>
          </div>
              <!-- <v-divider v-if="!$vuetify.breakpoint.xsOnly"></v-divider> -->
              <!-- <v-row :class="$vuetify.breakpoint.xsOnly?'mt-n6':'margin-top-btn-card'" justify="end"> -->
                    <!-- <v-col
      cols="12"
        md="5"
      >
              <v-list dense>
                <v-list-item class="mt-n2" style="color:#205295 !important;" >
                  <v-list-item-content style="max-width: 100px;" >{{
                    lg_listroom1.room_schedule
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ formatDate(item.meet_start) }}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="mt-n2">
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_date
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ formatDate(item.meet_create) }}
                  </v-list-item-content>
                </v-list-item>


                <v-list-item
                  :style="{
                    visibility:
                      item.meet_pass === null || item.meet_pass === ''
                        ? 'hidden'
                        : 'visible',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      visibility:
                        item.meet_pass === null || item.meet_pass === ''
                          ? 'hidden'
                          : 'visible',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.room_message_pass
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                class="mt-n2"
                  :style="{
                    display:
                      item.meet_verify_login === null || item.meet_verify_login === 'N'
                        ? 'none'
                        : 'show',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      display:
                        item.meet_verify_login === null || item.meet_verify_login === 'N'
                          ? 'none'
                          : 'show',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.require_sub_login2
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                class="mt-n2"
                  :style="{
                    display:
                      item.meet_verify_sta === null || item.meet_verify_sta === 'N'
                        ? 'none'
                        : 'show',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      display:
                        item.meet_verify_sta === null || item.meet_verify_sta === 'N'
                          ? 'none'
                          : 'show',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.enter_sub_email
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                class="mt-n2"
                  :style="{
                    display:
                      item.meet_verify_sta === null || item.meet_record_on_start_sta === 'N'
                        ? 'none'
                        : 'show',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_record
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      display:
                        item.meet_verify_sta === null || item.meet_record_on_start_sta === 'N'
                          ? 'none'
                          : 'show',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.room_record_detail
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>


                <v-list-item
                class="mt-n2"
                  :style="{
                    display:
                      item.meet_lobby_sta === 'N' ? 'none' : 'show',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_lobby
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      display:
                        item.meet_lobby_sta === 'N' ? 'none' : 'show',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.meet_sub__option_lobby
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col> -->
              <!-- <div class="d-flex flex-column">
                <v-btn
                  v-if="checkRoleAdmin"
                  class="mb-5 ml-5 mr-5 blue-grey lighten-5"
                  @click="doCopy('Admin', item)"
                >
                  Copy Invite Moderator Link
                </v-btn>
              </div> -->

              <!-- <v-col
              class="d-flex align-end"
      cols="12"
        md="7"
      >
              <v-row
      justify="end"
      class="mt-2"
    >
    
      <v-col
      class="text-center"
        cols="12"
        md="4"
        sm="12"
        sx="12"
      > -->
      <!-- class="mb-5 ml-5 mr-5 blue darken-3 white--text" -->
      <!-- <div class="d-flex flex-column" > -->
        <!-- :large="$vuetify.breakpoint.xsOnly" -->
      <!-- <v-btn
      :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly,'widthbtnjoinipad200': $vuetify.breakpoint.smOnly}"
        :large="$vuetify.breakpoint.xsOnly"
       color="#205295"
       outlined
                  class="mb-5 ml-2 mr-2 darken text-tranform-none"
                  @click="openInviteModal(item)"
                >
                  {{ lg_listroom1.btn_invite }}
                </v-btn>
              </div>
      </v-col> -->
         <!-- style="justify-items: center;" -->
      <!-- <v-col
        class="text-center"
        justify="center"
        cols="12"
        md="4"
        sm="12"
        sx="12"
      >
      <div class="d-flex flex-column" v-if="checkRoleAdmin" >
                <v-btn
                 :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly,'widthbtnjoinipad200': $vuetify.breakpoint.smOnly}"
                 :large="$vuetify.breakpoint.xsOnly"
                color="#205295"
                  class="mb-5 ml-2 mr-2 darken white--text text-tranform-none"
                  @click="onClickJoinMeetion(item)"
                >
                  {{ lg_listroom1.btn_join }}
                  <v-icon
        right
        dark
      >
      mdi-chevron-right
      </v-icon>
                </v-btn>
              </div>
      <div class="d-flex flex-column" v-if="!checkRoleAdmin">
                <v-btn
                 :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly,'widthbtnjoinipad200': $vuetify.breakpoint.smOnly}"
                :large="$vuetify.breakpoint.xsOnly"
                 color="#205295"
                  class="mb-5 ml-2 mr-2 darken white--text text-tranform-none"
                  @click="onClickJoinMeetion(item)"
                >
                  {{ lg_listroom1.btn_join }}
                  <v-icon
        right
        dark
      >
      mdi-chevron-right
      </v-icon>
                </v-btn>
              </div>
      </v-col>
    </v-row>
  </v-col>
  </v-row> -->
              <!-- <div class="d-flex flex-column">
                <v-btn
                  class="mb-5 ml-5 mr-5 blue darken-3 white--text"
                  @click="openInviteModal(item)"
                >
                  {{ lg_listroom1.btn_invite }}
                </v-btn>
              </div> -->

              <!-- @click="onClickJoinMeetion(item)" -->
              <!-- :href="item.meet_admin_link" -->
              <!-- <div class="d-flex flex-column" v-if="checkRoleAdmin">
                <v-btn
                  class="mb-5 ml-5 mr-5 green darken white--text text-tranform-none"
                  @click="onClickJoinMeetion(item)"
                >
                  {{ lg_listroom1.btn_join }}
                </v-btn>
              </div>
              <div class="d-flex flex-column" v-if="!checkRoleAdmin">
                <v-btn
                  class="mb-5 ml-5 mr-5 green darken white--text text-tranform-none"
                  @click="onClickJoinMeetion(item)"
                >
                  {{ lg_listroom1.btn_join }}
                </v-btn>
              </div> -->
              <!-- <div class="d-flex flex-column" v-if="acc_plan === 'PREMIUM'">
                <v-btn
                  class="mb-5 ml-5 mr-5 orange darken white--text text-tranform-none"
                  @click="onClickJoinLivestream(item)"
                >
                  {{ lg_listroom1.btn_join_livestream }}
                </v-btn>
              </div> -->
              <!-- <div class="d-flex flex-column">
                <v-btn
                  class="mb-5 ml-5 mr-5 grey darken-4 white--text"
                  @click="dialogCloseMeetion(item)"
                >
                  {{ lg_listroom1.btn_close }}
                </v-btn>
              </div> -->
        </div>
      </template>

      <!-- <template v-slot:footer>
        <v-row
          class="justify-space-between px-3 pt-5 pb-5"
          align="center"
          justify="center"
        >
          <v-spacer></v-spacer>
        </v-row>

        <v-layout class="justify-space-between mb-0 mt-5">
          <div>
            <span class="grey--text">Items per page</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  text
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div>
            <span class="mr-4 grey--text">
              Page {{ page }} of {{ numberOfPages }}
            </span>
            <v-btn
              outlined
              plain
              small
              color="blue darken-3"
              class="mr-1"
              @click="formerPage"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              outlined
              plain
              small
              color="blue darken-3"
              class="ml-1"
              @click="nextPage"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-layout>
      </template> -->
      <template v-slot:footer>
        <div class="lr-pager">
      <!-- <div class="d-flex align-center">
        <span class="grey--text" style="font-size:13px;">Items per page</span>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark text color="primary" class="ml-2" v-bind="attrs" v-on="on">
              {{ itemsPerPage }}
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(number, index) in itemsPerPageArray"
              :key="index"
              @click="updateItemsPerPage(number)"
            >
              <v-list-item-title>{{ number }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div> -->
          <button type="button" class="lr-page-btn" :disabled="page <= 1" @click="formerPage">
            <v-icon size="18" color="#475569">mdi-chevron-left</v-icon>
          </button>

          <button
            v-for="n in numberOfPages"
            :key="n"
            type="button"
            class="lr-page-btn"
            :class="{ 'is-active': page === n }"
            @click="page = n"
          >
            {{ n }}
          </button>

          <button type="button" class="lr-page-btn" :disabled="page >= numberOfPages" @click="nextPage">
            <v-icon size="18" color="#475569">mdi-chevron-right</v-icon>
          </button>
        </div>
      </template>
    </v-data-iterator>


    <LoadingDialog></LoadingDialog>

    <!-- Alert Dialog -->
    <v-dialog v-model="alertDlg" max-width="60%">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="alertDlg = false"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
            Confirm
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Alert Dialog -->
    <v-dialog v-model="dialog" scrollable width="unset">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" height="20">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4" align="center">

          <h3
            v-bind:style="{
              color: '#000000',
            }"
          >
            {{ this.lg_listroom1.dialog_invite_title }}
          </h3>
          <v-combobox
           class="mt-5"
            v-model="emails"
            outlined
            clearable
            :label="lg_listroom1.dialog_invite_send_to"
            multiple
            prepend-icon="mdi-email"
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                @click:close="removeEmail(item)"
              >
                <strong>{{ item }}</strong
                >&nbsp;
              </v-chip>
            </template>
          </v-combobox>

          <v-btn
            align="center"
            min-width="170"
            color="#3E73BB"
            class="rounded-pill"
            dark
            @click="inviteMembers(item)"
          >
            {{ this.lg_listroom1.btn_send }}
          </v-btn>

          <!-- <h3
           class="mt-5"
            v-clipboard:copy="message"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            align="center"
            v-bind:style="{
              color: '#000000',
              align: 'left',
              textDecoration: 'underline',
              cursor: 'pointer',
            }"
          >
            {{ this.lg_listroom1.dialog_invite_copy_link }}
          </h3> -->

          <!-- <h3
           class="mt-5 mb-2"
            v-clipboard:copy="messagelivestream"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            align="center"
            v-bind:style="{
              color: '#000000',
              align: 'left',
              textDecoration: 'underline',
              cursor: 'pointer',
            }"
            @click="onClickMenu('/contact')"
          >
            {{ this.lg_listroom1.dialog_invite_copy_link_livestream }}
          </h3> -->
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <!-- <v-card-actions>
          <v-btn
            class="mx-1"
            text
            color="blue darken-1"
            v-clipboard:copy="message"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <v-icon dark right> mdi-content-copy </v-icon>
            {{ this.lg_listroom1.dialog_invite_copy_link }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="inviteMembers">
            <v-icon dark right> mdi-send </v-icon>
            {{ this.lg_listroom1.dialog_invite_send_link }}
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogclosemeeting" width="unset">
      <v-card>
        <v-card-title class="text-h5">
          {{ this.lg_listroom1.dialog_delete }}</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="canceldialogCloseMeetion"
            >{{ this.lg_listroom1.cancel }}</v-btn
          >
          <v-btn color="red darken-1" text @click="confirmdialogCloseMeetion"
            >{{ this.lg_listroom1.delete }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- width="unset" -->
    <v-dialog v-model="moreinfodialog" scrollable max-width="700" content-class="md-dialog">
      <div class="md-card">
        <!-- ===== Header ===== -->
        <div class="md-header">
          <!-- ซ้าย -->
          <h3 class="md-title">{{ lg_listroom1.lr_md_title || lg_listroom1.more_info }}</h3>
          <!-- ขวา -->
          <span v-if="isLive(moreinfodialogdata)" class="lr-status lr-status--live">
            <i class="lr-dot"></i>{{ lg_listroom1.lr_status_live }}
          </span>
          <span v-else class="lr-status lr-status--scheduled">{{ lg_listroom1.lr_status_scheduled }}</span>
          <button type="button" class="md-close" @click="moreinfodialog = false">
            <v-icon size="18" color="#475569">mdi-close</v-icon>
          </button>
        </div>

        <div class="md-body">
          <!-- ===== ข้อมูลการประชุม ===== -->
          <div class="md-grid">
            <div>
              <p class="md-label">{{ lg_listroom1.room_name }}</p>
              <p class="md-value">{{ moreinfodialogdata.meet_topic }}</p>
            </div>
            <div>
              <p class="md-label">{{ lg_listroom1.lr_md_meeting_id }}</p>
              <p class="md-value md-value--row">
                {{ moreinfodialogdata.meet_name }}
                <button
                  type="button"
                  class="lr-icon-btn"
                  v-clipboard:copy="moreinfodialogdata.meet_name"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <v-icon size="15" color="#215295">mdi-content-copy</v-icon>
                </button>
              </p>
            </div>
                <!-- <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_id
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end" style="font-size:16px;">
                    {{ moreinfodialogdata.meet_name }}
                  </v-list-item-content>
                </v-list-item> -->

            <div>
              <p class="md-label">{{ lg_listroom1.lr_md_schedule_date }}</p>
              <!-- green--text -->
              <p class="md-value">{{ fmtDayLocal(moreinfodialogdata.meet_start) }}</p>
            </div>
            <div>
              <p class="md-label">{{ lg_listroom1.lr_md_schedule_time }}</p>
              <p class="md-value">{{ fmtTimeLocal(moreinfodialogdata.meet_start) }} · GMT+7</p>
            </div>

            <div>
              <p class="md-label">{{ lg_listroom1.lr_md_created }}</p>
              <p class="md-value">{{ fmtDayLocal(moreinfodialogdata.meet_create) }}</p>
            </div>
            <div>
              <p class="md-label">{{ lg_listroom1.lr_md_owner || lg_listroom1.room_user }}</p>
              <p class="md-value">{{ moreinfodialogdata.tbl_account?moreinfodialogdata.tbl_account.acc_fullname:"" }}</p>
            </div>

                <!-- <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_company
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end" style="font-size:16px;">
                    {{ moreinfodialogdata.company_name }}
                  </v-list-item-content>
                </v-list-item> -->

                <!-- <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_department
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end" style="font-size:16px;">
                    {{ moreinfodialogdata.department_name }}
                  </v-list-item-content>
                </v-list-item> -->
          </div>

          <!-- ===== ลิงก์การประชุม ===== -->
          <div class="md-section">
            <p class="md-label">{{ lg_listroom1.lr_md_link }}</p>
            <div class="md-link-row">
              <div class="md-link">{{ moreinfodialogdata.meet_user_link }}</div>
              <button
                type="button"
                class="lr-btn lr-btn--ghost md-btn-copy"
                v-clipboard:copy="moreinfodialogdata.meet_user_link"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <v-icon size="15" color="#215295">mdi-content-copy</v-icon>
                <span class="md-blue">{{ lg_listroom1.lr_md_copy }}</span>
              </button>
            </div>
          </div>

          <!-- ===== การเข้าถึงและการตั้งค่า ===== -->
          <div class="md-section">
            <p class="md-label">{{ lg_listroom1.lr_md_access }}</p>
            <div class="lr-tags">
              <span v-if="moreinfodialogdata.meet_verify_sta && moreinfodialogdata.meet_verify_sta !== 'N'" class="lr-tag">
                <v-icon size="13" color="#215295">mdi-cellphone</v-icon>{{ lg_listroom1.lr_tag_otp }}
              </span>
              <span v-if="moreinfodialogdata.meet_pass" class="lr-tag">
                <v-icon size="13" color="#215295">mdi-lock-outline</v-icon>{{ lg_listroom1.lr_tag_passcode }}
              </span>
              <span v-if="moreinfodialogdata.meet_verify_login && moreinfodialogdata.meet_verify_login !== 'N'" class="lr-tag">
                <v-icon size="13" color="#215295">mdi-account-key-outline</v-icon>{{ lg_listroom1.lr_tag_signin }}
              </span>
              <span v-if="moreinfodialogdata.meet_record_on_start_sta && moreinfodialogdata.meet_record_on_start_sta !== 'N'" class="lr-tag lr-tag--red">
                <i class="lr-dot lr-dot--red"></i>{{ lg_listroom1.lr_tag_record }}
              </span>
              <span v-if="moreinfodialogdata.meet_lobby_sta && moreinfodialogdata.meet_lobby_sta !== 'N'" class="lr-tag">
                <v-icon size="13" color="#215295">mdi-clock-outline</v-icon>{{ lg_listroom1.lr_tag_waiting }}
              </span>
            </div>

            <div v-if="moreinfodialogdata.meet_pass" class="lr-pass mt-3">
              <v-icon size="15" color="#64748b">mdi-lock-outline</v-icon>
              <span class="lr-pass-label">{{ lg_listroom1.password }}</span>
              <!-- {{
              item.meet_pass
            }} -->
              <span class="lr-pass-value" :class="{ 'is-hidden': !moreinfodialogdata.showpass }">
                {{ moreinfodialogdata.showpass ? moreinfodialogdata.meet_pass : '••••••' }}
              </span>
              <button type="button" class="lr-icon-btn" @click="$set(moreinfodialogdata, 'showpass', !moreinfodialogdata.showpass)">
                <v-icon size="15" color="#94a3b8">{{ moreinfodialogdata.showpass ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
              </button>
            </div>
          </div>

          <!-- ===== คำเชิญ ===== -->
          <div class="md-section">
            <p class="md-label">{{ lg_listroom1.lr_md_invitation }}</p>
            <div class="md-btn-row">
              <button type="button" class="lr-btn lr-btn--outline" @click="moreinfodialog = false; openInviteModal(moreinfodialogdata)">
                <v-icon size="16" color="#215295">mdi-email-outline</v-icon>
                {{ lg_listroom1.btn_invite }}
              </button>
              <button
                type="button"
                class="lr-btn lr-btn--ghost"
                @click="assignMessage(moreinfodialogdata)"
                v-clipboard:copy="message"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <v-icon size="16" color="#475569">mdi-content-copy</v-icon>
                {{ lg_listroom1.lr_md_copy_invite }}
              </button>
            </div>
          </div>
        </div>

        <!-- ===== Footer ===== -->
        <div class="md-footer">
          <!-- <button type="button" class="lr-btn md-btn-danger" @click="moreinfodialog = false; dialogCloseMeetion(moreinfodialogdata)">
            <v-icon size="16" color="#dc2626">mdi-close-circle-outline</v-icon>
            {{ lg_listroom1.lr_md_close_meeting }}
          </button> -->

          <div class="md-footer-right">
            <!-- <button
              type="button"
              class="lr-btn lr-btn--ghost"
              v-clipboard:copy="moreinfodialogdata.meet_user_link"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <v-icon size="16" color="#475569">mdi-content-copy</v-icon>
              {{ lg_listroom1.lr_md_copy_link }}
            </button> -->
            <button type="button" class="lr-btn lr-btn--primary" @click="onClickJoinMeetion(moreinfodialogdata)">
              <v-icon size="16" color="#ffffff">mdi-video-outline</v-icon>
              {{ lg_listroom1.lr_md_join || lg_listroom1.btn_join }}
              <v-icon size="16" color="#ffffff">mdi-chevron-right</v-icon>
            </button>
          </div>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="dialogcreateroom" scrollable max-width="720" content-class="cm-dialog">
      <div class="cm-card">
            <!-- <v-card-title>
          <v-spacer></v-spacer> -->
          <!-- <v-btn
  color="#205295"
  @click="dialogcreateroom = false"
  height="20"
  width="20"
  fab
  small
>
  <v-icon color="white">mdi-close</v-icon>
</v-btn> -->
        <!-- </v-card-title> -->
        <!-- <v-divider></v-divider> -->
            <!-- formCreateMeetroom -->
            <!-- <br /> -->
            <!-- <h3 class="text-center">
              <v-icon color="info">mdi-shield-account</v-icon>
              {{ this.lg_create_meetroom.title }}
            </h3> -->
        <form class="cm-form" @submit.prevent="onSubmit">
          <!-- ===== Header ===== -->
          <div class="cm-header">
                    <!--  v-bind:style="{ color: '#205295' }" -->
            <div>
              <h2 class="cm-title">{{ lg_create_meetroom.create_room_now }}</h2>
              <p class="cm-subtitle">{{ lg_create_meetroom.cm_subtitle }}</p>
            </div>
            <button type="button" class="cm-close" @click="dialogcreateroom = false">
              <v-icon size="18" color="#475569">mdi-close</v-icon>
            </button>
          </div>

          <div class="cm-body">
                <!-- <img src="/logo.png" alt="" class="app-logo" />
        <br /> -->
                  <!-- <v-tabs fixed-tabs background-color="#205295" dark>
                    <v-tabs-slider color="#FFE9B1"></v-tabs-slider>
                    <v-tab
                      :color="createMode === 'now' ? 'primary' : 'default'"
                      @click="createMode = 'now'"
                    >
                      {{ lg_create_meetroom.create_room_now }}
                    </v-tab>
                  </v-tabs> -->

            <!-- ===== ข้อมูลการประชุม ===== -->
            <p class="cm-section">{{ lg_create_meetroom.cm_section_info }}</p>

            <label class="cm-label" for="cm-topic">
              {{ lg_create_meetroom.meet_topic }} <span class="cm-required">*</span>
            </label>
            <input
              id="cm-topic"
              v-model="topic"
              type="text"
              class="cm-input"
              :placeholder="lg_create_meetroom.enter_meet_topic"
              autocomplete="off"
            />

            <label class="cm-label cm-label--mt">{{ lg_create_meetroom.create_meet_date }}</label>
            <datetime
              class="border-dt-picker minheighttime cm-datetime"
              type="datetime"
              input-id="menutimeadd"
              value-zone="Asia/Bangkok"
              :placeholder="lg_create_meetroom.select_meeting_date_and_time"
              v-model="datetime_meet_start"
              @input="getWorkHourDuration()"
            />
              <!-- <v-col cols="12" xl="7" lg="7" md="7" sm="7" xs="12" class="">
          </v-col> -->

            <div class="cm-tz">
              <span class="cm-tz-left">
                <v-icon size="15" color="#64748b">mdi-web</v-icon>
                {{ lg_create_meetroom.cm_timezone }}
              </span>
              <span v-if="meetSummary" class="cm-tz-right">{{ meetSummary }}</span>
            </div>

            <div class="cm-divider"></div>

            <!-- ===== การเข้าถึง ===== -->
            <p class="cm-section">{{ lg_create_meetroom.cm_section_access }}</p>

            <div class="cm-box">
              <div class="cm-row">
                <v-icon size="18" color="#475569">mdi-lock-outline</v-icon>
                <div class="cm-row-text">
                  <p class="cm-row-title">{{ lg_create_meetroom.passcode }}</p>
                  <p class="cm-row-desc">{{ lg_create_meetroom.passcode_subtitle }}</p>
                </div>
                  <!-- :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '16px' : '16px' }" -->
                <v-switch class="checkbox-options cm-switch" v-model="cbPassword" hide-details></v-switch>
              </div>

              <div v-if="cbPassword" class="cm-row-sub">
                  <!-- <template v-slot:label> -->
                    <!--  :placeholder="lg_create_meetroom.meet_password"  type="password" -->
                      <!-- :label="lg_create_meetroom.passcode" -->
                <label class="cm-label" for="cm-pass">{{ lg_create_meetroom.cm_passcode_label }}</label>
                <div class="cm-input cm-input--pass">
                  <input
                    id="cm-pass"
                    v-model="password"
                    :type="showcreatepass ? 'text' : 'password'"
                    :disabled="!cbPassword"
                    :placeholder="lg_create_meetroom.cm_passcode_label"
                    autocomplete="new-password"
                  />
                  <button type="button" class="cm-eye" @click="showcreatepass = !showcreatepass">
                    <v-icon size="16" color="#94a3b8">{{ showcreatepass ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                  </button>
                </div>
    <!-- </template> -->
              </div>
            </div>

            <div v-if="acc_plan !== 'FREE'">
              <div class="cm-box">
                <div class="cm-row">
                  <v-icon size="18" color="#475569">mdi-account-key-outline</v-icon>
                  <div class="cm-row-text">
                    <p class="cm-row-title">{{ lg_create_meetroom.requireauthenticationtojoin }}</p>
                    <p class="cm-row-desc">{{ lg_create_meetroom.cm_auth_desc }}</p>
                  </div>
                  <v-switch class="checkbox-options cm-switch" v-model="cbVerify" hide-details></v-switch>
                </div>

                <div v-if="cbVerify" class="cm-row-sub">
                <!-- :label="lg_create_meetroom.requireauthenticationtojoin" -->
                  <label class="cm-label">{{ lg_create_meetroom.cm_access_policy }}</label>
                  <v-select
                    class="custom-input cm-select"
                    :disabled="!cbVerify"
                    :items="requestauthentojoindatalist"
                    item-text="text"
                    item-value="value"
                    v-model="requestauthentojoin"
                    outlined
                    hide-details
                    dense
                    @click:clear="requestauthentojoin = null"
                    clearable
                  ></v-select>
                </div>
              </div>

              <div class="cm-divider"></div>

              <!-- ===== ตัวเลือกการประชุม ===== -->
              <p class="cm-section">{{ lg_create_meetroom.cm_section_options }}</p>

              <div class="cm-box">
                <div class="cm-row">
                  <i class="cm-dot-red"></i>
                  <div class="cm-row-text">
                    <p class="cm-row-title">{{ lg_create_meetroom.meet_option_record_on_start }}</p>
                    <p class="cm-row-desc">{{ lg_create_meetroom.cm_record_desc }}</p>
                  </div>
                  <v-switch class="checkbox-options cm-switch" v-model="cbRecordonStart" hide-details></v-switch>
                </div>
                <div v-if="cbRecordonStart" class="cm-alert">
                  <v-icon size="15" color="#dc2626">mdi-information-outline</v-icon>
                  {{ lg_create_meetroom.meet_option_sub_record_on_start }}
                </div>
              </div>

              <div class="cm-box">
                <div class="cm-row">
                  <v-icon size="18" color="#475569">mdi-clock-outline</v-icon>
                  <div class="cm-row-text">
                    <p class="cm-row-title">{{ lg_create_meetroom.meet_option_lobby }}</p>
                    <p class="cm-row-desc">{{ lg_create_meetroom.meet_sub__option_lobby }}</p>
                  </div>
                  <v-switch class="checkbox-options cm-switch" v-model="cbLobby" hide-details></v-switch>
                </div>
              </div>
            </div>

                  <!-- <v-switch class="checkbox-options"
                    v-model="selected"
                    :label="lg_create_meetroom.meet_option_share_screen"
                    value=""
                  ></v-switch> -->
          </div>

          <!-- ===== Footer ===== -->
          <div class="cm-footer">
          <!-- <v-spacer></v-spacer> -->
            <button type="button" class="lr-btn lr-btn--ghost" @click="dialogcreateroom = false">
              {{ lg_create_meetroom.btn_cancel }}
            </button>
          <!-- <v-row class="justify-center mb-5  mt-5 "> -->
            <button type="submit" class="lr-btn lr-btn--primary">
              {{ lg_create_meetroom.meet_create }}
            </button>
            <!-- </v-row> -->
          </div>

          <LoadingDialog v-if="resultVisible"></LoadingDialog>
          <ZoomCreateRoomSuccessDialog
            :visible="resultVisible"
            :result="result"
            @close="
              () => {
                resultVisible = false;
                loadListRoomMeetingData();
              }
            "
          />
        </form>
      </div>
    </v-dialog>

    <v-dialog
  v-model="dialogdeactivate"
  max-width="500"
  persistent
>
  <v-card
    class="pa-6 text-center"
    style="border-radius: 24px;"
  >
    <!-- Title -->
    <div class="text-h6 font-weight-bold mb-3">
    Your account is currently deactivated. Would you like to reactivate it?
    </div>

    <v-row justify="center" no-gutters>
      <v-btn
        text
        color="green"
        class="mr-6"
       @click="ReactivateData()"
      >
        Reactivate
      </v-btn>

      <v-btn
        text
        color="black"
         @click="Logout()"
      >
        Logout
      </v-btn>
    </v-row>

  </v-card>
</v-dialog>
  </v-container>
</template>

<script>
import api from "@/services/api";
import LoadingDialog from "@/components/cards/LoadingDialog.vue";
import { server } from "../services/constants";
import { format } from "date-fns";

import { feature } from "../services/constants";
import { lg_listroom1 } from "./language/lg_listroom_1";
import { lg_create_meetroom } from "./language/lg_create_meet_room";
import ZoomCreateRoomSuccessDialog from "@/components/cards/ZoomCreateRoomResultDialog.vue";
import { parsejwt } from "@/views/jsfunction/parseJwtData";

export default {
  name: "listroom",
  beforeCreate() {
    if (api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login-account");
    }
    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_listroom1 = lg_listroom1.listroom1_th)
      : (this.lg_listroom1 = lg_listroom1.listroom1_en);

       localStorage.getItem(feature.LANGUAGE) === "th"
        ? (this.lg_create_meetroom = lg_create_meetroom.create_meetroom_th)
        : (this.lg_create_meetroom = lg_create_meetroom.create_meetroom_en);
  },
  async mounted() {
  //   let ts = 1759822264;
  //    if (ts.toString().length === 10) ts = ts * 1000;
  // const date = new Date(ts + 7 * 60 * 60 * 1000);
  //   alert(date.toISOString().slice(0, 19).replace("T", " "));
    const user_id = localStorage.getItem(server.USER_ID);
    const user_data = await api.getAccountById(user_id);
    this.account = user_data.data;
    
    if(user_data.data.status == "I"){
      this.dialogdeactivate = true;
      // return;
    }

    this.acc_plan = parsejwt(localStorage.getItem(server.TOKEN_KEY)).acc_plan;
    localStorage.setItem(server.MEET_STA, "false");
    if (localStorage.getItem(server.ROLE) == "Admin") {
      this.checkRoleAdmin = true;
    }
    const userId = localStorage.getItem(server.USER_ID);
    if (!userId || !api.isLoggedIn()) {
      this.$router.push("/");
    }
    this.requestauthentojoindatalist=[{value:0,text:this.lg_create_meetroom.OTPverification},{value:1,text:this.lg_create_meetroom.LogintoDmeets}];
    // this.$store.state.loadMenu = true;
    this.$store.state.meetSta = false;
    this.$store.state.loadFooter = false;
    // this.$store.state.navMenu = true;
    this.loadListRoomMeetingData();
  },
  components: {
    LoadingDialog,
    ZoomCreateRoomSuccessDialog,
  },
  // new Date().toISOString(),
  data() {
    return {  
      account:null,
      dialogdeactivate:false,
      datetime_meet_start:null,
      showcreatepass: false,
      requestauthentojoin:null,
      requestauthentojoindatalist:[],
      reload_page: false,
      mDataArray: [],
      mDataPackageArray: [],
      privacy_sta: "false",
      privacyDlg: false,
      loading: false,
      resultVisible: false,
      createMode: "now",
      acc_plan: "",
      appId: "",
      apiKey: "",
      password: null,
      dateMenu: false,
      timeMenu: false,
      date: null,
      time: null,
      result: null,
      topic: null,
      resultJson: "",
      resultJsonCompanyName: null,
      username: "",
      cbPassword: false,
      cbRecordonStart: false,
      cbLobby: false,
      cbVerify: false,
      dialogcreateroom:false,
      moreinfodialog:false,
      moreinfodialogdata:{},
      acc_plan: "",
      e1: true,
      dataclosemeeting: null,
      dialogclosemeeting: false,
      message: null,
      messagelivestream: null,
      checkRoleAdmin: false,
      resultJson: "",
      itemsPerPageArray: [3, 6],
      search: "",
      alertDlg: false,
      titleMessageAlert: this.lg_listroom1.titleMessageAlert,
      messageAlert: this.lg_listroom1.messageAlert,
      role: "",
      filter: {},
      sortDesc: true,
      page: 1,
      itemsPerPage: 3,
      mDataArray: [],
      sortBy: "meet_start",
      keys: ["meet_name"],
      meetjoin: {
        meet_id: 0,
        meet_join_name: "",
        account_id: 0,
      },
      selected: null,
      meet: {
        meet_id_show: "",
        meet_name: "",
        meet_appid: "vpaas-magic-cookie-e205800afeca4002aad705d1994953cb",
        meet_apikey: "vpaas-magic-cookie-e205800afeca4002aad705d1994953cb/560000",
        meet_token: "",
        meet_sta: "Y",
        account_id: 0,
        company_id: 0,
        company_name: "",
        department_id: 0,
        department_name: "",
        meet_create: null,
        meet_end: null,
        meet_admin_link: "",
        meet_user_link: "",
        meet_pass: "",
        meet_topic: "",
        meet_start: null,
        meet_lobby_sta: "N",
        meet_verify_sta: "N",
        meet_verify_login:"N",
        meet_room_license: "FREE",
      },
      dialog: false,
      emails: [],
      selectedRoom: null,
      visiblePass: {},
    };
  },
  // watch: {
  //   moreinfodialogdata(newVal, oldVal) {
  //     console.log('Active changed from', oldVal, 'to', newVal);
  //     oldVal = newVal;
    
  //     // Do something when 'active' changes
  //   }
  // },
  computed: {
    // สรุปวัน-เวลาที่เลือก (โซนไทย)
    meetSummary() {
      if (!this.datetime_meet_start) return "";
      const d = this.toDate(this.datetime_meet_start);
      if (!d) return "";
      return this.fmtDay(d.toISOString()) + " · " + this.fmtTime(d.toISOString()) + " GMT+7";
    },
    numberOfPages() {
      return Math.ceil(this.mDataArray.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== "meet_name");
    },
  },
  methods: {
    // ===== helper สำหรับ UI ใหม่ =====
    toDate(date) {
      if (!date) return null;
      let d = date;
      if (typeof d === "string" && !/(Z|[+-]\d\d:?\d\d)$/.test(d)) {
        d = d.replace(" ", "T") + "Z";
      }
      const res = new Date(d);
      return isNaN(res.getTime()) ? null : res;
    },
    fmtDay(date) {
      const d = this.toDate(date);
      if (!d) return "-";
      return d.toLocaleDateString("en-GB", {
        timeZone: "Asia/Bangkok",
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
    fmtTime(date) {
      const d = this.toDate(date);
      if (!d) return "-";
      return d.toLocaleTimeString("en-US", {
        timeZone: "Asia/Bangkok",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    },
    // วันที่/เวลาตามภาษา (ใช้ใน dialog รายละเอียด)
    isThai() {
      return localStorage.getItem(feature.LANGUAGE) === "th";
    },
    fmtDayLocal(date) {
      const d = this.toDate(date);
      if (!d) return "-";
      return d.toLocaleDateString(this.isThai() ? "th-TH" : "en-GB", {
        timeZone: "Asia/Bangkok",
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
    fmtTimeLocal(date) {
      const d = this.toDate(date);
      if (!d) return "-";
      if (this.isThai()) {
        return d.toLocaleTimeString("th-TH", {
          timeZone: "Asia/Bangkok",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }) + " น.";
      }
      return this.fmtTime(date);
    },
    isLive(item) {
      const d = this.toDate(item.meet_start);
      return !!d && d.getTime() <= Date.now();
    },
    togglePass(item) {
      this.$set(this.visiblePass, item.meet_name, !this.visiblePass[item.meet_name]);
    },
    async ReactivateData(){
        const result_update_account = await api.updateAccount(
        this.account.id,
        {status:"A",date_deactivate:null,deactivate_description:null}
      );
         if(result_update_account.status == 401){
      this.$store.state.loadMenu = false;
       this.$store.dispatch("doLogout");
        return;
      }

      if (result_update_account.status == 200 || result_update_account.status == 201) {
      this.dialogdeactivate = false;
      }

    },
     async Logout(){
      this.$store.dispatch("doLogout");
      this.dialogdeactivate = false;
      return;

    },
    async onSubmit() {
        if((this.topic == "" || this.topic == null)){
          this.$swal.fire(this.lg_create_meetroom.titlemeeterror, this.lg_create_meetroom.checkmeet_topic, "error");
          return;
        }
                if((this.datetime_meet_start == "" || this.datetime_meet_start == null)){
          this.$swal.fire(this.lg_create_meetroom.titlemeeterror, this.lg_create_meetroom.checkmeet_dateandtime, "error");
          return;
        }
      
          if((this.cbPassword && (this.password == null || this.password == "")) || ((this.password != null && this.password != "") && !this.cbPassword)){
          this.$swal.fire(this.lg_create_meetroom.titlemeeterror, this.lg_create_meetroom.checkpasscode, "error");
          return;
        }

        if((this.cbVerify && (this.requestauthentojoin == null)) || ((this.requestauthentojoin !== null) && !this.cbVerify)){
          this.$swal.fire(this.lg_create_meetroom.titlemeeterror, this.lg_create_meetroom.checkrequireauthenticationtojoin, "error");
          return;

        }

        const { createMode, password, date, time, topic } = this;
        const userId = localStorage.getItem(server.USER_ID);
        try {
          let body = { password, host: window.location.origin, topic, userId };
          if (createMode === "schedule") {
            if (!date || !time) {
              throw new Error("กรุณากรอกวันและเวลาเริ่ม");
            }
            const dateOnly = format(parseISO(date), "yyyy-MM-dd");
            const startDate = parse(
              `${dateOnly} ${time}`,
              "yyyy-MM-dd HH:mm",
              new Date()
            );
            body = {
              ...body,
              startDate,
            };
          }
  
          this.$swal.showLoading();
  
          // const res = await axios.post("/rooms", body);
  
          // localStorage.setItem(server.MEET_STA, "true");
          // console.log(body)
        //   const res = await api.meetRoom(body);
        const res = await api.createMeetingdyte(body);

          
        //   return;
          if (res && res.data && res.data.status === "error") {
            this.$swal.fire(
              res.data.title || "Error",
              res.data.message || "Try again",
              "error"
            );
            return;
          }
          localStorage.setItem(server.MEET_STA, "false");
  
          // {"id":"2221240092272505",
          // "roomName":"2221 2400 9227 2505",
          // "password":null,
          // "startDate":null,
          // "topic":"44444",
          // "updatedAt":"2021-07-15T09:29:49.931Z",
          // "createdAt":"2021-07-15T09:29:49.931Z",
          // "modLink":"http://localhost:8080/meet/vpaas-magic-cookie-0d676e1889ea4299a153f25b1d1ee9f4/2221240092272505?moderator=true",
          // "userLink":"http://localhost:8080/meet/vpaas-magic-cookie-0d676e1889ea4299a153f25b1d1ee9f4/2221240092272505"}
  
          // console.log(JSON.stringify(res.data));
          // if (this.createMode == "schedule") {
          //   alert("schedule");
          // alert(JSON.stringify(res.data));
          this.$store.state.loadMenu = true;
          this.username = localStorage.getItem(server.USERNAME);
          this.resultJson = await api.checkRegister(this.username);
  
          // this.resultJsonCompanyName = await api.getCompanyByID(
          //   this.resultJson.data.company_id
          // );
          // this.meet.meet_token = token;
          this.meet.meet_id_show = res.data.roomName;
          this.meet.meet_name = res.data.id;
          this.meet.meet_appid = res.data.meet_appid;
          this.meet.meet_apikey = res.data.meet_appid;
          this.meet.meet_admin_link = `${window.location.origin}/meet/${res.data.id}`;
          this.meet.meet_user_link = `${window.location.origin}/meet/${res.data.id}`;
        //   this.meet.meet_admin_link = res.data.modLink;
        //   this.meet.meet_user_link = res.data.userLink;
          this.meet.meet_pass = this.password;
          this.meet.meet_topic = res.data.topic;
          // if (this.createMode == "schedule") {
          //   this.meet.meet_start = new Date();
          // } else {
          //   this.meet.meet_start = this.currentDateTime();
          // }
          this.meet.meet_start = `${this.datetime_meet_start.split("T")[0]} ${this.datetime_meet_start.split("T")[1].substring(0,5)}`;

          if (this.cbRecordonStart == true) {
            // alert("schedule");
            this.meet.meet_record_on_start_sta = "Y";
          } else {
            this.meet.meet_record_on_start_sta = "N";
          }
  
          if (this.cbLobby == true) {
            // alert("schedule");
            this.meet.meet_lobby_sta = "Y";
          } else {
            this.meet.meet_lobby_sta = "N";
          }
  
          // if (this.cbVerify == true) {
          //   this.meet.meet_verify_sta = "Y";
          // } else {
          //   this.meet.meet_verify_sta = "N";
          // }

          if(this.cbVerify && this.requestauthentojoin !== null){
            if(this.requestauthentojoin == 0){
              this.meet.meet_verify_sta = "Y";
              this.meet.meet_verify_login = "N";
              
            }else if(this.requestauthentojoin == 1){
              this.meet.meet_verify_sta = "N";
              this.meet.meet_verify_login = "Y";
            }else{
              this.meet.meet_verify_sta = "N";
              this.meet.meet_verify_login = "N";
            }

          }else{
            this.meet.meet_verify_sta = "N";
            this.meet.meet_verify_login = "N";
          }
  
          // alert(this.meet.meet_start);
  
          //   this.meet.meet_appid = this.appId;
          //   this.meet.meet_apikey = this.appId;
          this.meet.account_id = this.resultJson.data.id;
          this.meet.company_id = this.resultJson.data.company_id;
          // this.meet.company_name = this.resultJsonCompanyName.data.company_name;
          this.meet.company_name = localStorage.getItem(server.COMPANY_NAME);
          this.meet.department_id = localStorage.getItem(server.DEPARTMENT_ID);
          this.meet.department_name = localStorage.getItem(
            server.DEPARTMENT_NAME
          );
  
          // alert(this.meet.department_id);
          // alert(this.meet.department_name);
          this.meet.meet_create = this.currentDateTime();
          this.meet.meet_end = this.currentDateTime();
  
          if (localStorage.getItem(server.ROLE) == "Admin") {
            this.meet.meet_room_license = "PREMIUM";
          } else {
            this.meet.meet_room_license = localStorage.getItem(server.TOKEN_KEY)?parsejwt(localStorage.getItem(server.TOKEN_KEY)).acc_plan?parsejwt(localStorage.getItem(server.TOKEN_KEY)).acc_plan:"FREE":"FREE";
                        // this.meet.meet_room_license = localStorage.getItem(
            //   server.ACC_PLAN_STA
            // );
          }
  
          // alert(this.meet.meet_room_license);
        //   await api.addMeet(this.meet);
         await api.addMeetdyte(this.meet);
        
  
          this.meetjoin.meet_join_name = this.resultJson.data.acc_fullname;
          this.meetjoin.account_id = this.resultJson.data.id;
  
          this.resultJson = await api.checkByNameMeetdyte(
            this.meet.meet_name,
            this.meet.account_id
          );
          this.meetjoin.meet_id = this.resultJson.data.id;
  
          await api.addMeetJoin(this.meetjoin);
          this.$store.state.navMenu = false;
          this.$store.state.loadMenu = false;
          // }
          // this.result = {
          //   ...res.data,
          //   meet_user_link_meeting:this.meet.meet_user_link+"/meeting",
          //   ...this.meet,
          //   password,
          // };
            this.result = {
            ...res.data,
            meet_user_link_meeting:this.meet.meet_user_link,
            ...this.meet,
            password,
          };
          
          this.resultVisible = true;
          this.loading = true;
          this.date = null;
          this.time = null;
          this.topic = null;
          this.datetime_meet_start = null;
          this.password = null;
          this.dialogcreateroom = false;
          this.$swal.close();
  
          this.loading = false;
        } catch (error) {
          this.$store.state.loadMenu = false;
          this.$swal.close();
          this.loading = false;
          // this.$swal.fire("Error", error.message, "error");
          this.$swal.fire("Error",this.lg_create_meetroom.enter_meeting_details, "error");
          console.log(error);
        }
      },
    async Clickdialogcreate(){
      this.dialogcreateroom = true;
      
    },
   async moreinfodialogfn(item){
      this.moreinfodialogdata = {};
      this.moreinfodialogdata = item;
this.moreinfodialog = true;
    },
    onCopy() {
      this.dialog = false;
      this.$swal.fire("Success", "Copied", "success");
    },
    onError() {
      this.$swal.fire("Error", "Can Not Copy", "error");
    },
    openInviteModal(item) {
      this.selectedRoom = item;
      this.assignMessage(item);
      this.dialog = true;
    },
    assignMessage(item) {
      // old format date format(new Date(item.meet_start), "MMM dd, yyyy HH:mm")
      this.message =
        `${item.tbl_account.acc_fullname} is inviting you to a scheduled Dmeets meeting.\nAttorney-Client Privileged Communication\n\n` +
        `Topic:${item.meet_topic ?? "-"}\n` +
        `${
          item.meet_start
            ? `Time: ${
  new Date(item.meet_start)
    .toLocaleString("en-GB", {
      timeZone: "Asia/Bangkok",
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .toUpperCase() + " Bangkok Time (UTC/GMT+7)"
}\n\n`
            : ""
        }` +
        "Join Dmeets Meeting:\n" +
        item.meet_user_link +
        // "/meeting" +
        "\n\n" +
        "Meeting Number:\n" +
        item.meet_name +
        "\n" +
        `${item.meet_pass ? `Password:\n${item.meet_pass}\n` : ""}`;

      this.messagelivestream =
        `${item.tbl_account.acc_fullname} is inviting you to a scheduled Dmeets meeting.\n\n` +
        `Topic:${item.meet_topic ?? "-"}\n` +
        `${
          item.meet_start
            ? `Time: ${
                new Date(item.meet_start).toLocaleString("en-US", {
                  timeZone: "Asia/Bangkok",
                  dateStyle: "medium",
                  timeStyle: "short",
                }) + " Bangkok Time (UTC/GMT+7)"
              }\n\n`
            : ""
        }` +
        "Join Dmeets Livestream\n" +
        item.meet_user_link +
        "/livestream" +
        "\n\n" +
        "Meeting Number : \n" +
        item.meet_name +
        "\n" +
        `${item.meet_pass ? `Password:\n${item.meet_pass}\n` : ""}`;
    },
    removeEmail(item) {
      this.emails.splice(this.emails.indexOf(item), 1);
      this.emails = [...this.emails];
    },
    async inviteMembers() {
      this.assignMessage(this.selectedRoom);
      let setlink = `${this.selectedRoom.tbl_account.acc_fullname} has invited you to join a meeting via Dmeets, a secure and PDPA-compliant online meeting platform.\n\n` +
        `Meeting Title: ${this.selectedRoom.meet_topic ?? "-"}\n` +
        `${
          this.selectedRoom.meet_start
            ? `Date & Time: ${
                new Date(this.selectedRoom.meet_start).toLocaleString("en-US", {
                  timeZone: "Asia/Bangkok",
                  dateStyle: "medium",
                  timeStyle: "short",
                }) + " Bangkok Time (UTC/GMT+7)"
              }\n\n`
            : ""
        }` +
        "Join Link: " +
        this.selectedRoom.meet_user_link +
        // "/meeting" +
        "\n" +
        `${this.selectedRoom.meet_pass ? `Password: ${this.selectedRoom.meet_pass}\n\n` : `\n\n`}`+
        `No installation needed — just click the link to join from your browser or mobile.\n\n`+
        `This is an automated email from Dmeets. Please do not reply to this message.\n`+
        `If you have questions about the meeting, please contact the organizer directly.\n\n`+
        `Best regards,\n`+
        `Dmeets Team\n`+
        `https://dmeets.dcm.co.th\n`;
      try {
        this.$swal.showLoading();
        const payload = {
          members: this.emails,
          link: setlink,
          subject:`${this.selectedRoom.tbl_account.acc_fullname} invited you to a Dmeets meeting`,
        };
        const res = await api.inviteMembers(payload);
        if (res && res.data && res.data.status === "success") {
          this.dialog = false;
   this.$swal.fire({
  title:`<span style="color:black;">${this.lg_listroom1.invitation_sent}</span>`,
  html:`<span style="color:black;">${this.lg_listroom1.invitation_sent_details}</span>`,
  showDenyButton: false, 
  showCancelButton: false, 
  confirmButtonText: `${this.lg_listroom1.close}`,
  denyButtonText: `${this.lg_listroom1.close}`,
  confirmButtonColor: '#205295',
  denyButtonColor: '#000000',
  allowOutsideClick: true, 
  allowEscapeKey: true,  
  allowEnterKey: true   
}).then((result) => {
  if (result.isConfirmed) {
  } else if (result.isDenied) {
  }
});
        } else {
          this.$swal.fire("Error", res.data.message, "error");
        }
      } catch (e) {
        console.log(e);
        this.$swal.fire("Error", e.message, "error");
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      const [hh, mm] = day.split("T")[1].split(":");
      const hour = parseInt(hh);
      return `${year}-${month}-${day.split("T")[0]} ${hour + 7}:${mm}`;
    },
    async loadListRoomMeetingData() {
      this.mDataArray = [];

      let role = localStorage.getItem(server.ROLE);
      let company_id = localStorage.getItem(server.COMPANYID);
      let department_id = localStorage.getItem(server.DEPARTMENT_ID);
      let userId = localStorage.getItem(server.USER_ID);
      let result = null;

      if (role == "Admin") {
        result = await api.listRoomMeetingdyte();
      } else if (role == "Company Admin") {
        result = await api.listRoomMeetingByCompanydyte(company_id);
      } else {
        // result = await api.listRoomMeetingByDepartmentdyte(department_id);
        result = await api.listRoomMeetingByAccountCreatedyte(userId);
      }

      //   console.log(result);
      // let count = result.data.count;
      // for (let i=0;i<count;i++){
      //     this.mDataArray.push(result.data.rows.[i]);
      // }
     
      if(result.status == 401){
       this.$store.dispatch("doLogout");
        return;
        // this.$router.push("/");
      }else{
  this.mDataArray = result.data.rows;
      }
    
      // console.log(this.mDataArray)
      // console.log(JSON.stringify(this.mDataArray));
      this.$store.state.loadMenu = false;
    },
    async dialogCloseMeetion(item) {
      this.dataclosemeeting = item;
      this.dialogclosemeeting = true;
    },
    async canceldialogCloseMeetion() {
      this.dataclosemeeting = null;
      this.dialogclosemeeting = false;
    },
    async confirmdialogCloseMeetion(item) {
      this.dialogclosemeeting = false;
      await this.onClickCloseMeetion(this.dataclosemeeting);
    },
    async onClickCloseMeetion(item) {
      this.username = localStorage.getItem(server.USERNAME);
      this.resultJson = await api.checkRegister(this.username);
      const userId = localStorage.getItem(server.USER_ID);
      this.meet.user_update = userId;
      this.meet.lastuser_update = new Date();
      this.role = localStorage.getItem(server.ROLE);
      if (this.role == "Admin") {
        // console.log("Admin");
        // alert("Admin Close Room");
        this.$store.state.loadMenu = true;
        // this.meet.meet_sta = "N";
        // await api.deleteMeetdyte(item.meet_id_show);
        await api.updateMeetdyte(item.meet_id_show,{meet_sta:'N'});
        this.loadListRoomMeetingData();
      } else {
        if (item.account_id == this.resultJson.data.id) {
          // alert("Account Close Room");
          this.$store.state.loadMenu = true;
          // this.meet.meet_sta = "N";
          // await api.deleteMeetdyte(item.meet_id_show);
          await api.updateMeetdyte(item.meet_id_show,{meet_sta:'N'});
          this.loadListRoomMeetingData();
        } else {
          this.titleMessageAlert = this.lg_listroom1.titleMessageAlert;
          this.messageAlert = this.lg_listroom1.messageAlert;
          this.alertDlg = true;
          return;
        }
      }
    },
    async onClickJoinMeetion(item) {
      this.$store.state.loadMenu = true;

      localStorage.setItem("jwt", item.meet_token);

      // console.log("token : " + item.meet_token);

      this.username = localStorage.getItem(server.USERNAME);
      this.resultJson = await api.checkRegister(this.username);

      this.meetjoin.meet_join_name = this.resultJson.data.acc_fullname;
      this.meetjoin.account_id = this.resultJson.data.id;
      this.meetjoin.meet_id = item.id;

      if (
        localStorage.getItem(server.USER_ID) == item.account_id ||
        localStorage.getItem(server.ROLE) == "Admin" ||
        localStorage.getItem(server.ROLE) == "Company Admin"
      ) {
        localStorage.setItem(server.MODERATOR_STA, "true");
      } else {
        localStorage.setItem(server.MODERATOR_STA, "false");
      }

      // console.log("token111 : ", localStorage.getItem(server.MODERATOR_STA));
      // console.log("token111 : ", localStorage.getItem(server.ROLE));
      // console.log("token111 : ", localStorage.getItem(server.USER_ID));

      // await api.addMeetJoin(this.meetjoin);

      // this.$store.state.meetSta = false;
      this.$store.state.navMenu = false;
      this.$store.state.loadMenu = false;

      // alert(item.id);
      // this.$router.push(`/meet/${item.meet_appid}/${item.meet_name}`);
      // this.$router.push(`/meet/${item.meet_name}/meeting`);
       this.$router.push(`/meet/${item.meet_name}`);
    },
    async onClickJoinLivestream(item) {
      this.$store.state.loadMenu = true;
      localStorage.setItem("jwt", item.meet_token);
      // console.log("token : " + item.meet_token);
      this.username = localStorage.getItem(server.USERNAME);
      this.resultJson = await api.checkRegister(this.username);
      this.meetjoin.meet_join_name = this.resultJson.data.acc_fullname;
      this.meetjoin.account_id = this.resultJson.data.id;
      this.meetjoin.meet_id = item.id;
      if (
        localStorage.getItem(server.USER_ID) == item.account_id ||
        localStorage.getItem(server.ROLE) == "Admin" ||
        localStorage.getItem(server.ROLE) == "Company Admin"
      ) {
        localStorage.setItem(server.MODERATOR_STA, "true");
      } else {
        localStorage.setItem(server.MODERATOR_STA, "false");
      }
      // console.log("token111 : ", localStorage.getItem(server.MODERATOR_STA));
      // console.log("token111 : ", localStorage.getItem(server.ROLE));
      // console.log("token111 : ", localStorage.getItem(server.USER_ID));
      await api.addMeetJoin(this.meetjoin);
      // this.$store.state.meetSta = !this.$store.state.meetSta;
      this.$store.state.navMenu = false;
      this.$store.state.loadMenu = false;
      // alert(item.id);
      // this.$router.push(`/meet/${item.meet_appid}/${item.meet_name}`);
      this.$router.push(`/meet/${item.meet_name}/livestream`);
    },
    async getWorkHourDuration() {
        // if (
        //   this.datetime_meet_start !== "" &&
        //   this.datetime_meet_start !== ""
        // ) {
          // console.log(this.datetime_meet_start)
          // this.meet.meet_start = `${datetime_meet_start.split("T")[0]} ${datetime_meet_start.split("T")[1].substring(0,5)}`;
        // }
      },
         getMaxTime() {
        const selected = moment.tz(this.datetime_meet_start, "Asia/Bangkok").format("YYYY-MM-DD");
        const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

        // if (selected === today) {
        //   return moment.tz("Asia/Bangkok").format("HH:mm");
        // }
        // return null;
      },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    currentDateTime() {
        const current = new Date();
        const date =
          current.getFullYear() +
          "-" +
          (current.getMonth() + 1) +
          "-" +
          current.getDate();
        const time =
          current.getHours() +
          ":" +
          current.getMinutes() +
          ":" +
          current.getSeconds();
        const dateTime = date + " " + time;
  
        return dateTime;
      },
  },
};
</script>

<style scoped>
.text-tranform-none {
  text-transform: none;
}
.widthbtnjoinmobile200{
  width: 200px;
  align-self: center;
}
.widthbtnjoinipad200{
  width: 350px;
  align-self: center;
}
.border-dt-picker {
  border: 1px solid #d0d0d0;
  border-radius: 5px;
  height: 30px;
}

/* เพิ่ม: ให้ input ข้างในกว้าง 100% ด้วย */
.border-dt-picker >>> input {
  width: 100% !important;
}
.minheighttime {
  min-height: 40px;
  cursor: pointer;
  font-size: initial;
  padding-top: 7px;
  padding-left: 7px;
}
.v-card-style{
  border-radius: 8px;
}

.custom-input >>> .v-label {
  display: none;
}

.custom-input >>> fieldset {
  border-color: #d0d0d0;
  border-radius: 8px;
}

.custom-input >>> .v-input__slot {
  min-height: 40px;
}

.dashed-divider {
  border-top: 1px dashed #ccc !important;
}
 tbody {
     tr:hover {
        background-color: transparent !important;
     }
  }

/* ===================== UI ใหม่ (list meeting) ===================== */
.lr-page { color: #0f172a; }

/* Toolbar */
.lr-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  flex-wrap: wrap;
}
.lr-search {
  flex: 0 1 400px;
  min-width: 0;
  height: 44px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.lr-search:focus-within {
  border-color: #215295;
  box-shadow: 0 0 0 3px rgba(33, 82, 149, 0.12);
}
.lr-search input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  font: inherit;
  font-size: 14px;
  color: #0f172a;
}
.lr-search input::placeholder { color: #94a3b8; }
.lr-search-clear { background: none; border: 0; padding: 0; cursor: pointer; display: flex; }

/* Buttons */
.lr-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.lr-btn--primary { background: #215295; border: 1px solid #215295; color: #ffffff !important; }
.lr-btn--primary:hover { background: #1b4580; }
.lr-btn--outline { background: #ffffff; border: 1px solid #215295; color: #215295 !important; }
.lr-btn--outline:hover { background: #f1f5fb; }
.lr-btn--ghost { background: #ffffff; border: 1px solid #e2e8f0; color: #475569 !important; font-weight: 500; }
.lr-btn--ghost:hover { background: #f8fafc; }
.lr-btn--sm { height: 32px; padding: 0 12px; font-size: 13px; }
.lr-btn--icon { width: 34px; padding: 0; }
.lr-btn--create {
  height: 44px;
  padding: 0 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(33, 82, 149, 0.25);
}

/* Empty */
.lr-empty {
  margin-top: 48px;
  padding: 56px 24px;
  text-align: center;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
}
.lr-empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #e8eef6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.lr-empty h2 { font-size: 18px; font-weight: 600; color: #215295; margin: 0; }

/* Grid (head + card ใช้ชุดคอลัมน์เดียวกัน) */
.lr-head,
.lr-card {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr) minmax(0, 1.4fr) minmax(0, 1.2fr);
  column-gap: 24px;
}
.lr-head {
  padding: 24px 24px 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}
.lr-head-actions { padding-left: 24px; }

/* Card */
.lr-card {
  padding: 22px 24px 30px;
  margin-bottom: 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}
.lr-card:hover { border-color: #cbd5e1; box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06); }
.lr-col { min-width: 0; }
.lr-col p { margin: 0; }

/* Meeting */
.lr-title { font-size: 16px; font-weight: 700; margin: 0 0 4px; word-break: break-word; }
.lr-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin-bottom: 12px !important;
}
.lr-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
}
.lr-status--live { background: #dcfce7; color: #15803d; }
.lr-status--scheduled { background: #e8eef6; color: #215295; }
.lr-dot { width: 7px; height: 7px; border-radius: 50%; background: #22c55e; display: inline-block; }
.lr-dot--red { background: #ef4444; }

/* Dates */
.lr-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 2px !important;
}
.lr-date { font-size: 14px; font-weight: 600; color: #0f172a; }
.lr-date--live { color: #15803d; }
.lr-time { font-size: 12px; color: #475569; }

/* Settings */
.lr-tags { display: flex; flex-wrap: wrap; gap: 6px; }
.lr-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 4px;
  background: #e8eef6;
  color: #215295;
  font-size: 12px;
  font-weight: 500;
}
.lr-tag--red { background: #fef2f2; color: #dc2626; }
.lr-pass {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 13px;
  color: #334155;
}
.lr-pass-value { font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; margin-left: 4px; }
.lr-pass-value.is-hidden { letter-spacing: 2px; }
.lr-icon-btn { background: none; border: 0; padding: 2px; cursor: pointer; display: inline-flex; }

/* Actions */
.lr-col--actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}
.lr-actions-top,
.lr-actions-main { display: flex; gap: 8px; }

/* Pager */
.lr-pager { display: flex; align-items: center; gap: 6px; margin-top: 20px; }
.lr-page-btn {
  min-width: 40px;
  height: 40px;
  padding: 0 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  font: inherit;
  font-size: 14px;
  color: #0f172a;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
/* .lr-page-btn:hover:not(:disabled) { background: #f8fafc; } */
.lr-page-btn:disabled { opacity: 0.45; cursor: default; }
.lr-page-btn.is-active { background: #215295; border-color: #215295; color: #ffffff; font-weight: 600; }

/* ===== Tablet (< 960px): 2 คอลัมน์ ===== */
@media (max-width: 959px) {
  .lr-head { display: none; }
  .lr-card {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    row-gap: 18px;
    margin-top: 16px;
  }
  .lr-col--actions {
    grid-column: 1 / -1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    border-top: 1px solid #f1f5f9;
  }
}

/* ===== Mobile (< 600px): คอลัมน์เดียว ===== */
@media (max-width: 599px) {
  .lr-search { flex: 1 1 100%; }
  .lr-btn--create { width: 100%; }
  .lr-card { grid-template-columns: minmax(0, 1fr); padding: 18px 16px 20px; }
  .lr-col--actions { flex-direction: column-reverse; align-items: stretch; }
  .lr-actions-top { justify-content: space-between; }
  .lr-actions-main { flex-direction: column; }
  .lr-actions-main .lr-btn { width: 100%; height: 40px; }
  .lr-pager { justify-content: center; flex-wrap: wrap; }
}

/* ===================== Dialog รายละเอียดการประชุม ===================== */
.md-card {
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
  color: #0f172a;
}
::v-deep .md-dialog { border-radius: 16px; box-shadow: 0 24px 60px rgba(15, 23, 42, 0.25); }
.md-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 32px;
  border-bottom: 1px solid #e2e8f0;
}
.md-title { flex: 1; font-size: 20px; font-weight: 700; margin: 0; color: #0f172a; }
.md-close {
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.md-close:hover { background: #f8fafc; }

.md-body { padding: 24px 32px; overflow-y: auto; }
.md-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 18px 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e2e8f0;
}
.md-label {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  margin: 0 0 4px !important;
}
.md-value { font-size: 15px; color: #0f172a; margin: 0 !important; word-break: break-word; }
.md-value--row { display: flex; align-items: center; gap: 8px; }

.md-section { padding: 22px 0; border-bottom: 1px solid #e2e8f0; }
.md-section:last-child { border-bottom: 0; padding-bottom: 4px; }
.md-link-row { display: flex; gap: 8px; margin-top: 8px; }
.md-link {
  flex: 1;
  min-width: 0;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 13px;
  color: #475569;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.md-btn-copy { height: 40px; }
.md-blue { color: #215295; font-weight: 600; }
.md-section .lr-tags { margin-top: 8px; }
.md-btn-row { display: flex; gap: 12px; flex-wrap: wrap; margin-top: 8px; }
.md-btn-row .lr-btn,
.md-footer .lr-btn { height: 40px; }

.md-footer {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 12px;
  padding: 16px 32px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}
.md-footer-right { display: flex; gap: 10px; }
.md-btn-danger { background: #fef2f2; border: 1px solid #fca5a5; color: #dc2626 !important; }
.md-btn-danger:hover { background: #fee2e2; }

@media (max-width: 599px) {
  .md-header, .md-body, .md-footer { padding-left: 18px; padding-right: 18px; }
  .md-grid { grid-template-columns: minmax(0, 1fr); }
  .md-footer { flex-direction: column-reverse; align-items: stretch; }
  .md-footer-right { flex-direction: column; }
  .md-footer .lr-btn, .md-btn-row .lr-btn { width: 100%; }
}

/* ===================== Dialog สร้างห้องประชุม ===================== */
.cm-card {
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
  color: #0f172a;
}
.cm-form { display: flex; flex-direction: column; min-height: 0; }
::v-deep .cm-dialog { border-radius: 16px; }
.cm-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 22px 28px 18px;
  border-bottom: 1px solid #e2e8f0;
}
.cm-title { flex: 1; font-size: 20px; font-weight: 700; margin: 0; }
.cm-subtitle { font-size: 13px; color: #64748b; margin: 4px 0 0; }
.cm-header > div:first-child { flex: 1; min-width: 0; }
.cm-close {
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.cm-close:hover { background: #f8fafc; }

.cm-body { padding: 20px 28px 8px; overflow-y: auto; }
.cm-section {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  margin: 0 0 12px;
}
.cm-label { display: block; font-size: 14px; font-weight: 600; margin: 0 0 6px; }
.cm-required { color: #dc2626; }
.cm-input {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font: inherit;
  font-size: 14px;
  color: #0f172a;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.cm-input::placeholder { color: #94a3b8; }
.cm-input:focus,
.cm-input:focus-within { border-color: #215295; box-shadow: 0 0 0 3px rgba(33, 82, 149, 0.12); }
.cm-input--icon,
.cm-input--pass { display: flex; align-items: center; gap: 10px; }
.cm-input--icon input,
.cm-input--pass input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  font: inherit;
  font-size: 14px;
  color: #0f172a;
  background: transparent;
}
.cm-eye { background: none; border: 0; padding: 2px; cursor: pointer; display: inline-flex; }
.cm-label--mt { margin-top: 18px; }
.cm-datetime {
  width: 100%;
  height: 44px !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 8px !important;
  display: flex;
  align-items: center;
  padding: 0 14px !important;
}
.cm-datetime ::v-deep input {
  width: 100%;
  border: 0;
  outline: none;
  font: inherit;
  font-size: 14px;
  color: #0f172a;
  background: transparent;
  cursor: pointer;
}
.cm-tz {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding: 10px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #475569;
}
.cm-tz-left { display: inline-flex; align-items: center; gap: 6px; }
.cm-tz-right { color: #215295; font-weight: 600; }
.cm-divider { height: 1px; background: #e2e8f0; margin: 24px 0 20px; }

.cm-box {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  margin-bottom: 12px;
  overflow: hidden;
}
.cm-row { display: flex; align-items: flex-start; gap: 12px; padding: 16px 18px; }
.cm-row-text { flex: 1; min-width: 0; }
.cm-row-title { font-size: 14px; font-weight: 600; margin: 0; }
.cm-row-desc { font-size: 13px; color: #64748b; margin: 2px 0 0; }
.cm-row-sub { padding: 0 18px 16px; border-top: 1px solid #f1f5f9; padding-top: 14px; }
.cm-dot-red { width: 10px; height: 10px; border-radius: 50%; background: #dc2626; margin-top: 6px; flex-shrink: 0; }
.cm-switch { margin: 0 !important; padding: 0 !important; flex-shrink: 0; }
.cm-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 14px 14px;
  padding: 10px 12px;
  background: #fef2f2;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.5;
  color: #dc2626;
}
.cm-select ::v-deep .v-input__slot { min-height: 44px; }

.cm-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 28px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}
.cm-footer .lr-btn { height: 40px; }

@media (max-width: 599px) {
  .cm-header, .cm-body, .cm-footer { padding-left: 16px; padding-right: 16px; }
  .cm-footer { flex-direction: column-reverse; align-items: stretch; }
  .cm-footer .lr-btn { width: 100%; }
}
</style>